import React from 'react';

function Img(props) {
  const { src, defaultSrc, alt, className } = props;
  return (
    <img
      src={src ? src : defaultSrc}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = defaultSrc ? defaultSrc : '';
      }}
      alt={alt ? alt : ''}
      className={className}
    />
  );
}

export default Img;
